"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SubNavHeading = require("@ccw-pwa-ui/SubNavHeading");
var _react = _interopRequireDefault(require("react"));
var _StoreInformationTile = require("@ccw-pwa-ui/StoreInformationTile");
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _AlertTileComponent = require("@ccw-pwa-ui/AlertTileComponent");
var _reactBootstrap = require("react-bootstrap");
require("../styles/CommonAlertList.scss");
const CommonAlertListComponent = props => {
  const {
    storeAlertList,
    storeName,
    storeAddress,
    navHeadingText,
    SubNavHeadingText,
    SubNavHeadingTitle
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_SubNavHeading.SubNavHeading, {
    heading: SubNavHeadingText,
    subHeading: SubNavHeadingTitle,
    separator: "|"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeadingText,
    handleBack: props.handleBack,
    leftArrowImage: _images.default.leftArrow.default
  })), storeName && /*#__PURE__*/_react.default.createElement("div", {
    className: "notificationStoreTile"
  }, /*#__PURE__*/_react.default.createElement(_StoreInformationTile.StoreInformationTile, {
    name: storeName,
    address: storeAddress,
    arrowImage: _images.default.ArrowRight.default,
    rightButtonShow: false
  })), storeAlertList !== null && storeAlertList !== void 0 && storeAlertList.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "alertListTile",
    "data-testid": "alert-list",
    style: {
      minHeight: "auto",
      alignSelf: "center"
    }
  }, storeAlertList.map((item, ind) => {
    const val = item.id + ind;
    return /*#__PURE__*/_react.default.createElement(_AlertTileComponent.AlertTileComponent, {
      key: val,
      variant: item.variant,
      isRead: !item.isRead,
      alertheading: item.alertheading,
      alertMessageType: item.alertMessageType,
      alertText: item.alertText,
      Description: item.Description,
      alertImageLeft: item.alertImageLeft,
      alertImageRight: item.alertImageRight,
      date: item.date,
      fullWidth: true,
      onClick: item.onClick
    });
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: "noALertClass",
    style: {
      padding: "35px",
      fontSize: "13px",
      fontFamily: "poppins",
      lineHeight: "20px",
      fontWeight: 400
    }
  }, "This is where you will see the ", /*#__PURE__*/_react.default.createElement("strong", null, "Alerts and Notifications."), " These will appear here automatically once your account or products generate them."), props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null);
};
var _default = exports.default = CommonAlertListComponent;